import { useSelector } from 'react-redux'
import _ from 'lodash'

export const useAppSelector = (pathState) => useSelector((state) => _.get(state, pathState), _.isEqual)